import React from 'react';
import styles from './DocumentListVault.module.scss';
import { Box, TableCell, TableRow, Typography } from '@mui/material';
import CalendarIcon from '../../../../../assets/svg/calendar_month.svg?react';
import { Helpers } from '../../../../common/helpers/helpers';
import { useDocumentsFunctions } from '../../hooks/useDocumentsFunctions';
import EmployeeIcon from '@mui/icons-material/BadgeOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import CustomersIcon from '@mui/icons-material/SupportAgentOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import { DocumentsListRowProps } from './types';
import { useTranslation } from 'react-i18next';

export const DocumentsListRow = ({ doc, renderActionButtons }: DocumentsListRowProps) => {
  const { t } = useTranslation();
  const { getWorkflow, getProfileName, getProfileType, navigateToDocumentPageTab } =
    useDocumentsFunctions();
  const renderProfileIcon = (profileType: string) => {
    switch (profileType) {
      case 'employment':
        return <EmployeeIcon fontSize='small' />;
      case 'supplier':
        return <BusinessCenterOutlinedIcon fontSize='small' />;
      case 'customer':
        return <CustomersIcon fontSize='small' />;
      case 'business':
        return <ApartmentOutlinedIcon fontSize='small' />;
      default:
        return null;
    }
  };
  const profileType = getProfileType(doc.category);
  const profileIcon = renderProfileIcon(profileType);
  const timeDifference = Date.now() - new Date(doc.created).getTime();

  return (
    <TableRow className={`${styles.table_row} ${timeDifference < 300000 ? styles.doc_new : ''}`}>
      <TableCell className={styles.table_cell} onClick={() => navigateToDocumentPageTab(doc, 1)}>
        <Box className={styles.file_name_container}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {doc.name.endsWith('.pdf') || doc.name.endsWith('.docx') || doc.name.endsWith('.doc')
              ? doc.name.replace('.pdf', '').replace('.docx', '').replace('.doc', '')
              : doc.name}{' '}
            {timeDifference < 300000 ? (
              <Box className={styles.badge_new} sx={{ marginLeft: '10px' }}>
                {t('labels.new')}
              </Box>
            ) : null}
          </Box>
        </Box>
      </TableCell>
      <TableCell className={styles.table_cell} onClick={() => navigateToDocumentPageTab(doc, 1)}>
        <Box className={styles.profile_container}>
          {profileIcon && <Box className={styles.profile_icon}>{profileIcon}</Box>}
          <Typography variant='body2' className={styles.profile_text}>
            {getProfileName(profileType, doc).join(', ')}
          </Typography>
        </Box>
      </TableCell>
      <TableCell className={styles.table_cell} onClick={() => navigateToDocumentPageTab(doc, 1)}>
        <Typography variant='body2' className={styles.cell_text}>
          {getWorkflow(doc)}
        </Typography>
      </TableCell>
      <TableCell className={styles.table_cell} onClick={() => navigateToDocumentPageTab(doc, 1)}>
        <Box className={styles.date_container}>
          {doc.extras && doc.extras.length > 0 && doc.extras[0].start_date ? (
            <>
              <CalendarIcon />
              <Typography variant='body2' className={styles.cell_text}>
                {Helpers.timeStampToDateV2(doc.extras[0].start_date)}
              </Typography>
            </>
          ) : (
            '-'
          )}
        </Box>
      </TableCell>
      <TableCell className={styles.table_cell} onClick={() => navigateToDocumentPageTab(doc, 1)}>
        <Box
          className={`${styles.date_container} ${
            doc.extras &&
            doc.extras.length > 0 &&
            doc.extras[0].end_date &&
            new Date(doc.extras[0].end_date) < new Date()
              ? styles.overdue
              : doc?.extras[0]?.end_date &&
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  (new Date(doc?.extras[0]?.end_date) - new Date()) / 1000 / 60 / 60 / 24 < 30
                ? styles.getting_closer
                : ''
          }`}
        >
          {doc.extras && doc.extras.length > 0 && doc.extras[0].end_date ? (
            <>
              <CalendarIcon />
              <Typography variant='body2' className={styles.cell_text}>
                {Helpers.timeStampToDateV2(doc.key_date_end_date)}
              </Typography>
            </>
          ) : (
            '-'
          )}
        </Box>
      </TableCell>
      <TableCell className={styles.table_cell}>{renderActionButtons(doc)}</TableCell>
    </TableRow>
  );
};
